var _excluded = ["size", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Children } from "react";
import { ListItemContentWrapper, LiStyled } from "./ListItem.style";
import { useListSize } from "../ListSizeContext";

/* Общий компонент элемента списков для ul и ol */
var ListItem = function ListItem(_ref) {
  var sizeProperty = _ref.size,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var size = useListSize(sizeProperty); // Если в li больше одной ноды, нужно все обернуть в div, чтобы контент сложился в стопку справа от маркера

  var ChildrenWrapper = Children.toArray(children).length > 1 ? ListItemContentWrapper : React.Fragment;
  return /*#__PURE__*/React.createElement(LiStyled, _extends({
    size: size
  }, props), /*#__PURE__*/React.createElement(ChildrenWrapper, null, children));
};

export default ListItem;